import { For, Show } from "solid-js";
import { Icon } from "~/ui/Icon";

export interface WeekInfo {
  current_week: { display: string };
  day_dots?: Array<{ enabled: boolean; checked_out: boolean; checked_in: boolean; is_today: boolean }>;
  weekend_config?: { saturday?: boolean; sunday?: boolean };
}

const labels = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

export function WeekBanner(props: { value?: WeekInfo }) {
  return (
    <Show when={props.value}>{(value) => (
      <div class="card" style={{ padding: "9px 16px", "margin-bottom": "16px" }}>
        <div style={{ display: "flex", "justify-content": "space-between", "align-items": "center", "flex-wrap": "wrap", gap: "8px" }}>
          <span style={{ "font-weight": 800, color: "var(--primary-dark)", "font-size": "0.9rem", display: "flex", "align-items": "center", gap: "7px" }}>
            <Icon name="sparkle" style={{ width: "15px", height: "15px" }} /> {value().current_week.display}
          </span>
          <div style={{ display: "flex", gap: "1px", "flex-wrap": "nowrap" }}>
            <For each={value().day_dots ?? []}>{(day, index) => {
              const dot = () => !day.enabled ? "—" : day.checked_out ? "●" : day.checked_in ? "◑" : "○";
              const color = () => !day.enabled ? "#CBD5E1" : day.checked_out ? "var(--success-dark)" : day.checked_in ? "#F59E0B" : "#CBD5E1";
              return (
                <div style={{ display: "flex", "flex-direction": "column", "align-items": "center", gap: "2px", padding: "4px 7px", "min-width": "34px", background: day.is_today ? "var(--primary-light)" : undefined, "border-radius": day.is_today ? "8px" : undefined }}>
                  <span style={{ "font-size": "0.95rem", color: day.is_today ? "var(--ink)" : color() }}>{dot()}</span>
                  <span style={{ "font-size": "0.65rem", "font-weight": 700, color: day.is_today ? "var(--ink)" : undefined, "text-decoration": !day.enabled ? "line-through" : undefined, opacity: day.is_today ? 1 : 0.65 }}>{labels[index()] ?? ""}</span>
                </div>
              );
            }}</For>
          </div>
        </div>
      </div>
    )}</Show>
  );
}
